var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Some of the organisations SRG has worked for, either directly or as a subcontractor.")]),_c('b-table',{attrs:{"striped":"","items":_vm.clients}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }